module.exports = __webpack_public_path__ + "img/germany-pneumonia-male.1ee908a5.png";